// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "gallery" + "." + "d6e9aaf4" + ".js";
};